import React, { useState } from 'react'
import { Menu, Icons, Select, Radio, Button, Input, DatePicker, Tag, Space } from '@pankod/refine-antd'
import { useTestTracks } from 'utility/masterData'

const { RangePicker } = DatePicker

interface FilterItem {
  key: string
  value: string | string[]
  filterKey: string
  filterOp: string
  label: string
}

interface CandidateResultFilterProps {
  updateFilter?: (filters: any, clear?: boolean) => void
  filters: any
}

const CandidateResultFilter: React.FC<CandidateResultFilterProps> = ({ updateFilter, filters }) => {
  const [filterItems, setFilterItems] = useState<FilterItem[]>([])
  const [selectedMenuKey, setSelectedMenuKey] = useState<string>('all')
  const [testTrackSearch, setTestTrackSearch] = useState<string>('')

  const allTheFilterDetails = [
    {
      menuName: 'All Details',
      key: 'all',
      isLeaf: false,
      filterKey: 'all',
      filterOp: '',
    },
    {
      menuName: 'Type',
      key: 'type',
      isLeaf: true,
      filterKey: 'evaluation.paper.product.type',
      filterOp: 'eq',
    },
    {
      menuName: 'Test Track',
      key: 'test_track',
      isLeaf: true,
      filterKey: 'evaluation.paper.test_track_id',
      filterOp: 'contains',
    },
    {
      menuName: 'Evaluation Date',
      key: 'evaluation_date',
      isLeaf: true,
      filterKey: 'created_at',
      filterOp: 'between',
    },
    {
      menuName: 'Eligibility',
      key: 'eligibility',
      isLeaf: true,
      filterKey: 'is_eligible_for_result',
      filterOp: 'eq',
    },
  ]

  const typeMenu = ['skt', 'tq', 'te']
  const testTrackDetails = useTestTracks(true)

  const handleFilterSelect = (key: string, value: string | string[], label: string) => {
    const parseDateString = (dateStr: any) => {
      const [day, month, year] = dateStr.split('-')
      return `${year}-${month}-${day}`
    }

    const filterDetail = allTheFilterDetails.find(item => item.key === key)
    if (!filterDetail) return
    const newFilter: FilterItem = {
      key,
      value,
      filterKey: filterDetail.filterKey,
      filterOp: filterDetail.filterOp,
      label,
    }
    const updatedFilters = filterItems.filter(f => f.key !== key)
    updatedFilters.push(newFilter)
    setFilterItems(updatedFilters)
    console.log(updatedFilters, 'update filters')
    if (key === 'test_track') {
      const testTrackFilter = [{ field: 'evaluation.paper.test_track_id', operator: 'eq', value: value }]
      if (updateFilter) {
        updateFilter(testTrackFilter)
      }
    }
    if (key === 'type') {
      const typeFilter = [{ field: 'evaluation.paper.product.type', operator: 'eq', value: value }]
      if (updateFilter) {
        updateFilter(typeFilter)
      }
    }
    if (key === 'evaluation_date') {
      if (Array.isArray(value)) {
        const [startDateStr, endDateStr] = value
        const startDate = parseDateString(startDateStr)
        const endDate = parseDateString(endDateStr)
        const dateFilter = [
          { field: 'created_at', operator: 'gte', value: `${startDate}T00:00:00Z` },
          { field: 'created_at', operator: 'lte', value: `${endDate}T23:59:59Z` },
        ]

        if (updateFilter) {
          updateFilter(dateFilter)
        }
      }
    }
    if(key === 'eligibility'){
      const eligibilityFilter = [{ field: 'is_eligible_for_result', operator: 'eq', value: value }]
      if (updateFilter) {
        updateFilter(eligibilityFilter)
      }
    }
  }

  const handleFilterRemove = (filter: FilterItem) => {
    const updatedFilters = filterItems.filter(f => !(f.key === filter.key && JSON.stringify(f.value) === JSON.stringify(filter.value)))
    setFilterItems(updatedFilters)
    const itemRemovedFilter = filters?.filter((item: any) => filter.filterKey !== item.field)
    console.log(itemRemovedFilter,'Item Removed Filter')
    if (updateFilter) {
      updateFilter(itemRemovedFilter,true)
    }
  }

  const handleClearAll = () => {
    console.log(filters, 'filters')
    setFilterItems([])
    if (updateFilter) {
      console.log('Changing filter')
      updateFilter([], true)
    }
    setSelectedMenuKey('all')
  }

  const handleMenuClick = (e: any) => {
    const key = e.key.split('-')[0]
    setSelectedMenuKey(key)

    if (key === 'all') {
      handleClearAll()
    }
  }

  return (
    <div className="ams-filter-bar">
      {/* Selected Filters Display */}
      {filterItems.length > 0 && (
        <div className="ams-filter-tags">
          <Space style={{ flexWrap: 'wrap' }}>
            {filterItems.map(filter => (
              <Tag key={`${filter.key}-${JSON.stringify(filter.value)}`} closable onClose={() => handleFilterRemove(filter)} color="blue">
                {filter.label}
              </Tag>
            ))}
            <Button size="small" onClick={handleClearAll}>
              Clear All
            </Button>
          </Space>
        </div>
      )}

      {/* Filter Menu */}
      <Menu mode="horizontal" selectedKeys={[selectedMenuKey]} onClick={handleMenuClick} className="ams-filter-menu">
        {allTheFilterDetails.map((item, idx) => (
          <React.Fragment key={`${item.key}${idx}`}>
            {item.isLeaf ? (
              <Menu.SubMenu key={item.key} icon={<Icons.FilterOutlined />} title={item.menuName}>
                {item.key === 'digital_badge' && (
                  <>
                    <Menu.Item key="digital_badge-true" onClick={() => handleFilterSelect('digital_badge', 'true', 'Digital Badge: Yes')}>
                      Yes
                    </Menu.Item>
                    <Menu.Item key="digital_badge-false" onClick={() => handleFilterSelect('digital_badge', 'false', 'Digital Badge: No')}>
                      No
                    </Menu.Item>
                  </>
                )}
                {item.key === 'eligibility' && (
                  <>
                    <Menu.Item key="eligibility:Yes" onClick={() => handleFilterSelect('eligibility', 'true', 'eligibility:Yes')}>
                      Yes
                    </Menu.Item>
                    <Menu.Item key="eligibility:No" onClick={() => handleFilterSelect('eligibility', 'false', 'eligibility:No')}>
                      No
                    </Menu.Item>
                  </>
                )}
                {item.key === 'type' &&
                  typeMenu.map((option, idx) => (
                    <Menu.Item key={`type-${idx}`} onClick={() => handleFilterSelect('type', option, `Type: ${option.toUpperCase()}`)}>
                      {option.toUpperCase()}
                    </Menu.Item>
                  ))}
                {item.key === 'test_track' && (
                  <>
                    <Menu.Item key="test_track-search" disabled>
                      <Input
                        placeholder="Search Test Track"
                        allowClear
                        value={testTrackSearch}
                        onChange={e => setTestTrackSearch(e.target.value)}
                        onPressEnter={() => {
                          const matchedTrack = testTrackDetails?.data?.data?.find(
                            (track: any) => track.name.toLowerCase() === testTrackSearch.trim().toLowerCase()
                          )
                          if (matchedTrack) {
                            console.log(matchedTrack, 'Matched track')
                            handleFilterSelect('test_track', matchedTrack.id, matchedTrack.name)
                            setTestTrackSearch('') // clear search input after selection
                          }
                        }}
                        style={{ width: '100%' }}
                      />
                    </Menu.Item>

                    {testTrackDetails?.data?.data
                      ?.filter((track: any) => track.name.toLowerCase().includes(testTrackSearch.toLowerCase()))
                      .map((track: any) => {
                        const isAlreadySelected = filterItems.some(f => f.key === 'test_track' && f.value === track.name)
                        return (
                          <Menu.Item
                            key={`test_track-${track.id}`}
                            icon={<Icons.AppstoreOutlined />}
                            disabled={isAlreadySelected}
                            onClick={() => {
                              handleFilterSelect('test_track', track.id, `Test Track: ${track.name}`)
                              setTestTrackSearch('')
                            }}
                          >
                            {track.name}
                          </Menu.Item>
                        )
                      })}
                  </>
                )}

                {item.key === 'evaluation_date' && (
                  <Menu.Item key="test_date-picker" disabled>
                    <RangePicker
                      format="DD-MM-YYYY"
                      style={{ width: '100%' }}
                      onChange={(dates, dateStrings) => {
                        if (dateStrings[0] && dateStrings[1]) {
                          handleFilterSelect('evaluation_date', dateStrings, `evaluation_date: ${dateStrings[0]} to ${dateStrings[1]}`)
                        }
                      }}
                    />
                  </Menu.Item>
                )}
              </Menu.SubMenu>
            ) : (
              <Menu.Item key={item.key} icon={<Icons.AppstoreOutlined />}>
                {item.menuName}
              </Menu.Item>
            )}
          </React.Fragment>
        ))}
      </Menu>
    </div>
  )
}

export default CandidateResultFilter
